import React from 'react'

export default function Triangle(props) {
    return (
        <div {...props}>
            <svg width="39" height="33" viewBox="0 0 39 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.634 0.5C19.0189 -0.166667 19.9811 -0.166667 20.366 0.5L38.1195 31.25C38.5044 31.9167 38.0233 32.75 37.2535 32.75H1.74648C0.97668 32.75 0.495554 31.9167 0.880455 31.25L18.634 0.5Z" fill="#F1F1F1" />
            </svg>

        </div>
    )
}
